import {Injectable} from '@angular/core';
import {ActiveCartService} from '@spartacus/cart/base/core';

import {TransactionTypeTexts} from '@app/checkout/order-confirmation/order-confirmation-list-item/order-confirmation-order-item.model';
import {ConfiguratorProductService} from '@app/product/configurator/services/configurator-product.service';
import {TransactionTypeService} from '@app/services/transactionTypes/transaction-type.service';
import {OrderEntry} from '@spartacus/cart/base/root';
import {Observable} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TransactionTextsService {
  constructor(
    private activeCartService: ActiveCartService,
    private configuratorProductService: ConfiguratorProductService,
    private transactionTypeService: TransactionTypeService
  ) {}

  getTransactionTypeTexts$(): Observable<TransactionTypeTexts> {
    return this.configuratorProductService.getVariant$().pipe(
      switchMap((vp) => this.activeCartService.getEntry(vp.code)),
      map((cartEntry: OrderEntry) => this.transactionTypeService.getTransactionTypeCodeByUrlOrOrderEntry(cartEntry)),
      switchMap((ttCode) => this.transactionTypeService.getTranslations(ttCode))
    );
  }
}
